<template>
  <div class="CarefullyChosenItem tapActive" @click="$emit('linkToDetail', { id: itemInfo.IDStr })">
    <van-image
      fit="cover"
      class="pic"
      :src="itemInfo.MainPicUrl"
      error-icon="photo"
    />
    <div class="rightPart">
      <div class="title twoRow" v-text="itemInfo.Title"></div>
      <div class="subBottom">
        <div class="time">{{ itemInfo.CreateTime | formatTime("MM月DD日") }}</div>
        <div class="otherData">
          <div class="otherItem">
            <span class="iconfont icon-liulan"></span>
            <span>{{ itemInfo.ReadCount | formatMaxNum }}</span>
          </div>
          <div class="otherItem">
            <span class="iconfont icon-dianzan11"></span>
            <span>{{ itemInfo.LikeCount | formatMaxNum }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from "vant";
export default {
  name: "SouhuoH5Carefullychosenitem",

  props: {
    itemInfo: {
      type: Object
    }
  },

  data() {
    return {};
  },

  components: {
    VanImage
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.CarefullyChosenItem {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  padding: vw(10) 0;  
  .pic {
    flex-shrink: 0;
    width: vw(125);
    height: vw(75);
    border-radius: vw(5);
    overflow: hidden;
  }
  .rightPart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    padding-left: vw(9);
    .title {
        font-size: vw(15);
        color: #101010;
        opacity: .8;
        font-weight: 700;
    }
    .subBottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: vw(12);
      color: #999999;
      line-height: 1.1em;
      .otherData {
        display: flex;
        .otherItem {
          display: flex;
          align-items: center;
          margin-right: vw(12);
          .iconfont {
            font-size: vw(18);
          }
          .icon-dianzan11 {
            position: relative;
            top: vw(.7);
            font-size: vw(13);
            margin-right: vw(4);
          }
          .icon-liulan {
            position: relative;
            top: vw(1);
            font-size: vw(16);
            margin-right: vw(4);
          }
          .icon {
              margin-right: vw(4);
          }
          &:last-child {
              margin-right: 0;
          }
        }
      }
    }
  }
}
</style>